import { render, staticRenderFns } from "./InstallDetail.vue?vue&type=template&id=f9933ad8&scoped=true&"
import script from "./InstallDetail.vue?vue&type=script&lang=js&"
export * from "./InstallDetail.vue?vue&type=script&lang=js&"
import style0 from "./InstallDetail.vue?vue&type=style&index=0&id=f9933ad8&prod&lang=scss&scoped=true&"
import style1 from "./InstallDetail.vue?vue&type=style&index=1&id=f9933ad8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9933ad8",
  null
  
)

export default component.exports